module.exports = __webpack_public_path__ + "img/title.a1e64b8e.png";